import type { IAction } from "epics/base-epic";
import { SNACKBARS_ADD, SNACKBARS_REMOVE, SNACKBARS_CLEAR } from "constants/action-types";
import uuid from "uuid/v4";
import type { ICustomSnackbarAction } from "types/working-order/line-items";

export type SnackbarAddPayload = {
    id?: string;
    message?: string | JSX.Element;
    action?: string | JSX.Element;
    testId?: string;
    customAction?: ICustomSnackbarAction;
    shouldUseLatestSnack?: boolean;
    options?: object;
    onActionClick?: () => void;
    messageStyle?: { [key: string]: string | number };
};

export type SnackbarAddAction = IAction<SnackbarAddPayload>;

export type SnackbarAdd = (payload: SnackbarAddPayload) => SnackbarAddAction;

export const add: SnackbarAdd = (payload) => {
    if (!payload.id) {
        payload.id = uuid();
    }

    return { type: SNACKBARS_ADD, payload };
};

type SnackbarRemove = (id: string) => IAction<string>;

export const remove: SnackbarRemove = (id) => ({ type: SNACKBARS_REMOVE, payload: id });

export const clear = () => ({ type: SNACKBARS_CLEAR });

// aliases
export const snackbarAdd = add;
export const snackbarRemove = remove;
export const snackbarClear = clear;
